import {inject, Injectable} from "@angular/core";
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from "@angular/common/http";
import { Observable } from "rxjs/internal/Observable";
import { LocalstorageService } from "@services/localstorage.service";
import { NotifyService } from "@services/notify.service";
import {AuthService} from "../auth/auth.service";

@Injectable()
export class AccessSessionInterceptor implements HttpInterceptor {
  notifyOneMinute: boolean = false;
  notifyFiveMinutes: boolean = false;

  constructor(
    protected localstorageService: LocalstorageService,
    private _notifyService: NotifyService,
    private authService: AuthService
  ) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {

    const expiresSession:number = this.localstorageService.getExpiresSession();
    const nowMillis:number = new Date().getTime();
    const diffMillis:number = expiresSession - nowMillis;
    const oneMinuteMillis:number = 60 * 1000;
    const fiveMinutesMillis:number = 5 * 60 * 1000;
    const ssoRepomIdentity:boolean = this.authService.isTokenRepomIdentity;

    if (nowMillis > expiresSession && ssoRepomIdentity) {
      inject(AuthService).logOut();
    }
    else if ((diffMillis <= oneMinuteMillis && ssoRepomIdentity) && !this.notifyOneMinute) {
      this._notifyService.showError(
        "Sessão",
        "Sua sessão irá expirar em 1 minuto. Realize o login novamente para continuar usando a plataforma."
      );
      this.notifyOneMinute = true;

    }
    else if ((diffMillis <= fiveMinutesMillis && ssoRepomIdentity) && !this.notifyFiveMinutes) {
      this._notifyService.showError(
        "Sessão",
        "Sua sessão irá expirar em 5 minutos. Fique atento!"
      );
      this.notifyFiveMinutes = true
    }

    return next.handle(req);
  }
}
